<template>
    <div>
        <data-table-component :url="`/api/events/bookings/${bookingId}/payments/datatable`" :columns="columns" :is-searchable="false" table-container-class="data-table shadow-none">
            <template slot-scope="{ row }" slot="actions">
                <td class="text-right">
                    <a :href="`/admin/events/bookings/${bookingId}/payments/${row.id}/print`" target="_blank" class="button is-small is-tertiary inline-block">
                        <i class="fas fa-print"></i>
                    </a>
                    <a :href="`/admin/events/bookings/${bookingId}/payments/${row.id}/edit`" class="button is-small is-tertiary inline-block">
                        <i class="fas fa-edit"></i>
                    </a>
                </td>
            </template>
        </data-table-component>
    </div>
</template>

<script>
    import DataTableComponent from '../DataTableComponent';
    import moment from 'moment';

    export default {
        components: {
            DataTableComponent,
        },

        props: {
            booking: {
                type: Number,
                required: true
            }
        },

        data() {
            return {
                columns: [
                    {
                        key: 'transaction',
                        label: 'Reference',
                    },
                    {
                        key: 'method_id',
                        label: 'Method',
                        html: (key, value, row) => {
                            return row.method.name;
                        }
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        html: (key, value, row) => {
                            return row.status.toLowerCase().replace(/^(.)|\s+(.)/g, function ($1) {
                                return $1.toUpperCase()
                            });
                        }
                    },
                    {
                        key: 'amount',
                        label: 'Amount',
                        html: (key, value, row) => {
                            return row.currency.symbol + row.amount;
                        }
                    },
                    {
                        key: 'date',
                        label: 'Date',
                        html: (key, value, row) => {
                            return moment(row.date).format('DD-MM-YYYY HH:mm');
                        }
                    }
                ],

                bookingId: this.booking,

                currentRow: {},
                isDeleteModalVisible: false,
            }
        }
    }
</script>
